import { CMProfileSocial } from './cm-profile-social.model';
import { CMProfileCompany } from './cm-profile-company.model';
import { CMProfileSchool } from './cm-profile-school.model';
import { CMProfileInterest } from './cm-profile-interest.model';

export class CMProfile {

    public name: string;
    public surname: string;
    public headline: string;
    public biography: string;
    public photo: string;
    public socials: CMProfileSocial[];
    public educations: CMProfileSchool[];
    public experiences: CMProfileCompany[];
    public lookingForJob: boolean;
    public nationality: string;
    public basedIn: string;
    public basedInC: string;
    public basedInR: string;
    public interests: CMProfileInterest[];
    public communities: string[];
    public languages: string[];
    public roles: string[];
    public jobData: any;


    public constructor() {
        this.name = '';
        this.surname = '';
        this.headline = '';
        this.biography = '';
        this.photo = '';
        this.socials = [];
        this.educations = [];
        this.experiences = [];
        this.lookingForJob = false;
        this.nationality = '';
        this.basedIn = '';
        this.basedInC = '';
        this.basedInR = '';
        this.interests = [];
        this.communities = [];
        this.languages = [];
        this.roles = [];
        this.jobData = {};
    }

    public fromRaw(data) {
        this.name = data.name || '';
        this.surname = data.surname || '';
        this.headline = data.headline || '';
        this.biography = data.biography || '';
        this.photo = data.photo || '#';
        this.lookingForJob = data.lookingForJob || false;
        this.nationality = data.nationality || '';
        this.basedIn = data.basedIn || '';
        this.basedInC = data.basedInC || '';
        this.basedInR = data.basedInR || '';
        this.jobData = data.jobData || {};

        if (data.socials && data.socials.length > 0) {
            data.socials.forEach((s) => {
                this.socials.push((new CMProfileSocial()).fromRaw(s));
            });
        }

        if (data.educations && data.educations.length > 0) {
            data.educations.forEach((s) => {
                this.educations.push((new CMProfileSchool()).fromRaw(s));
            });
        }

        if (data.experiences && data.experiences.length > 0) {
            data.experiences.forEach((s) => {
                this.experiences.push((new CMProfileCompany()).fromRaw(s));
            });
        }

        if (data.communities && data.communities.length > 0) {
            this.addCommunities(data.communities);
        }

        if (data.interests && data.interests.length > 0) {
            data.interests.forEach((s: any) => {
                this.addInterest((new CMProfileInterest()).fromRaw(s));
            });
        }

        if (data.languages && data.languages.length > 0) {
            this.addLanguages(data.languages);
        }

        return this;
    }

    public addSocial(social: CMProfileSocial): CMProfile {
        const sIndex = this.socials.findIndex((s) => {
            return s.type === social.type;
        });
        if (sIndex === -1) {
            this.socials.push(social);
        } else {
            this.socials[sIndex].link = social.link;
        }
        return this;
    }

    public addCommunity(community: string): CMProfile {
        this.communities.push(community);
        this.communities = this.communities.filter((elem, pos) => {
            return this.communities.indexOf(elem) === pos && elem !== '';
        });
        return this;
    }

    public addCommunities(communities: string[]): CMProfile {
        this.communities.push(...communities);
        this.communities = this.communities.filter((elem, pos) => {
            return this.communities.indexOf(elem) === pos && elem !== '';
        });
        return this;
    }

    public addInterest(interest: CMProfileInterest): CMProfile {
        const iIndex = this.interests.findIndex((i) => i.refId === interest.refId);
        if (iIndex === -1) {
            this.interests.push(interest);
        } else {
            this.interests[iIndex] = interest;
        }
        return this;
    }

    public addLanguage(language: string): CMProfile {
        this.languages.push(language);
        this.languages = this.languages.filter((elem, pos) => {
            return this.languages.indexOf(elem) === pos && elem !== '';
        });
        return this;
    }

    public addLanguages(languages: string[]): CMProfile {
        this.languages.push(...languages);
        this.languages = this.languages.filter((elem, pos) => {
            return this.languages.indexOf(elem) === pos && elem !== '';
        });
        return this;
    }

    public hasRole(role: string): boolean {
        return this.roles.includes(role);
    }

}
